import React, { FC, useMemo } from 'react';
import ReactDOMServer from 'react-dom/server';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { windowService } from '../../../../../utils/window.utils';
import { seperateSplitsAndMatched } from '../../../../../utils/regex.utils';
import { TFormatText } from '../../../types/index.types';

const FormatText: FC<TFormatText> = ({ text, searchTerm, editable = false, extraClassName = '', tagname, onClick }) => {
  const highlightText = (splits: Array<string>, matched: Array<string>): JSX.Element[] => {
    return splits.map((split, idx) => (
      <>
        <span className="model-detail-specification-table__text">{split}</span>
        <span className="model-detail-specification-table__text model-detail-specification-table__text--highlight">{matched[idx]}</span>
      </>
    ));
  };

  const searchInNodes = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const internalText = node.textContent || text;
      const { splits, matched } = seperateSplitsAndMatched(internalText, searchTerm);
      const result = splits.length === matched.length + 1 ? highlightText(splits, matched) : text;
      const highlightedText = ReactDOMServer.renderToString(<>{result}</>);
      const span = document.createElement('span');
      span.innerHTML = highlightedText;
      if (node.parentNode) {
        node.parentNode.insertBefore(span, node);
        node.parentNode.removeChild(node);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      for (const childNode of Array.from(node.childNodes)) {
        searchInNodes(childNode);
      }
    }
  };

  const serializedText = useMemo((): string => {
    if (searchTerm) {
      if (!windowService()?.DOMParser) return text;
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      searchInNodes(doc.body);
      return doc.body.innerHTML;
    }
    return text;
  }, [searchTerm]);

  return <RichText field={{ value: serializedText }} editable={editable} tag={tagname} extraClassName={extraClassName} onClick={onClick} />;
};

export default FormatText;
